import { render } from "./playGame.vue?vue&type=template&id=74c1d780&scoped=true"
import script from "./playGame.vue?vue&type=script&lang=js"
export * from "./playGame.vue?vue&type=script&lang=js"

import "./playGame.vue?vue&type=style&index=0&id=74c1d780&scoped=true&lang=scss"

import exportComponent from "/Users/liuli/Desktop/istory/vue3-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c1d780"]])

export default __exports__